import type { Truthy } from '@/types/utilityTypes';

export function truthy<T>(value: T): value is Truthy<T> {
  return !!value;
}

export function nonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
